var _path, _ellipse, _ellipse2, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F6F6F6"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AF1317"
    },
    cx: 250,
    cy: 250,
    r: 161.117
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#AF1317",
      strokeWidth: 2.0495,
      strokeMiterlimit: 10
    },
    cx: 250,
    cy: 250,
    r: 168.834
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 250,
    cy: 250,
    r: 119.555
  }), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.059,207.31H172.637c-8.053,0-14.582,6.528-14.582,14.582v76.862c0,8.053,6.529,14.582,14.582,14.582h149.422 c8.053,0,14.582-6.528,14.582-14.582v-76.862C336.641,213.838,330.112,207.31,322.059,207.31z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2238 -0.9746 0.9746 0.2238 -61.733 443.1274)",
    cx: 247.348,
    cy: 260.322,
    rx: 61.71,
    ry: 61.71
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2116 -0.9774 0.9774 0.2116 -59.4224 446.9789)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 247.348,
    cy: 260.322,
    rx: 53.409,
    ry: 53.409
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1582 -0.9874 0.9874 0.1582 -48.8201 463.382)",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5.9721,
      strokeMiterlimit: 10
    },
    cx: 247.348,
    cy: 260.322,
    rx: 40.877,
    ry: 40.877
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2288 -0.9735 0.9735 0.2288 -62.6566 441.5566)",
    cx: 247.348,
    cy: 260.322,
    rx: 10.021,
    ry: 10.021
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M257.95,253.693c0,3.602-2.92,6.523-6.523,6.523c-3.602,0-6.523-2.92-6.523-6.523 s2.92-6.523,6.523-6.523C255.03,247.17,257.95,250.091,257.95,253.693z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.829,193.341H174.27c-2.024,0-3.664,1.64-3.664,3.664v6.195h25.887v-6.195 C196.493,194.981,194.853,193.341,192.829,193.341z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.378,170.257h-32.356c-4.83,0-8.745,3.915-8.745,8.745v9.976c0,4.83,3.915,8.745,8.745,8.745h32.356 c4.83,0,8.745-3.915,8.745-8.745v-9.976C329.123,174.173,325.208,170.257,320.378,170.257z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M318.202,175.596h-28.003c-2.617,0-4.738,2.121-4.738,4.738v7.314 c0,2.617,2.121,4.738,4.738,4.738h28.003c2.617,0,4.738-2.121,4.738-4.738v-7.314 C322.94,177.717,320.819,175.596,318.202,175.596z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 288.67,
    y: 199.69,
    width: 31.55,
    height: 5.302
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 242.106,
    y: 113.317,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -103.5534 250)",
    style: {
      fill: "#AF1317"
    },
    width: 15.787,
    height: 273.366
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_x5F_1_x5F_",
    style: {
      fill: "none"
    },
    d: "M381.646,250c0,72.706-58.94,131.647-131.646,131.647 S118.354,322.706,118.354,250S177.294,118.354,250,118.354S381.646,177.294,381.646,250z"
  }), /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("textPath", {
    xlinkHref: "#SVGID_x5F_1_x5F_",
    startOffset: "81.0737%"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Poppins-Bold'",
      fontSize: 20,
      letterSpacing: 100
    }
  }, "NO PHOTO        NO PHOTO        NO PHOTO        NO PHOTO        NO PHOTO"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M280.297,113.652c0,1.119-0.907,2.027-2.027,2.027c-1.119,0-2.027-0.907-2.027-2.027 c0-1.119,0.907-2.027,2.027-2.027C279.389,111.625,280.297,112.532,280.297,113.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.564,344.882c0,1.119-0.907,2.027-2.027,2.027c-1.119,0-2.027-0.907-2.027-2.027 c0-1.119,0.907-2.027,2.027-2.027C148.657,342.855,149.564,343.762,149.564,344.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M130.9,181.736c0,1.119-0.907,2.027-2.027,2.027c-1.119,0-2.027-0.907-2.027-2.027 c0-1.119,0.907-2.027,2.027-2.027C129.993,179.709,130.9,180.616,130.9,181.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M389.939,235.796c0,1.119-0.907,2.027-2.027,2.027c-1.119,0-2.027-0.907-2.027-2.027 c0-1.119,0.907-2.027,2.027-2.027C389.031,233.769,389.939,234.677,389.939,235.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.745,377.382c0,1.119-0.907,2.027-2.027,2.027c-1.119,0-2.027-0.907-2.027-2.027 c0-1.119,0.907-2.027,2.027-2.027C310.837,375.355,311.745,376.263,311.745,377.382z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no-photo.f09054edca4b949251b4c7e6fd16da64.svg";
export { ForwardRef as ReactComponent };